import axios from 'axios';
import ui from './ui';
import a from 'aes-js';
import p from 'pbkdf2';

const apiUrl = process.env.VUE_APP_API_URL || 'https://poswebapi.azurewebsites.net/api/';
const imageBaseUrl = 'https://hotelcrmimages.blob.core.windows.net/images/';

function getApiUrl(methodName) {
	return `${apiUrl.replace(/\/$/, '')}/${methodName.replace(/^\//, '')}`;
}

function log(msg, opts) {
	const style = `background: ${opts?.bg || 'none'}; color: ${opts?.color || '#333'}; padding: 1px 4px; border-radius: 4px;`;
	const log = [`%c${msg}`, style];
	if (arguments?.length > 2) {
		log.push(...[...arguments].slice(2, 999).filter(f => f));
	}

	if (__DEBUG__ || opts?.always)
		console.debug(...log);
}

function get(methodName, params, pageSize, opts) {
	const timerName = `${methodName} ${JSON.stringify(params) || ''}`.trim();
	if (__DEBUG__)
		console.time(timerName);
	return axios.get(getApiUrl(methodName), {
		params,
		headers: {
			pageSize: pageSize || 9999
		},
		...(opts|| {})
	})
		.then(r => {
			log('GET', { bg: 'blue', color: 'white' }, methodName, params, r?.data);
			if (__DEBUG__)
				console.timeEnd(timerName);
			return r?.data;
		})
		.catch(ex => {
			log('GET', { bg: 'red', color: 'white' }, methodName, params, ex);
			ui.notifyError(ex)
		});
}

function post(methodName, data, opts) {
	if (__DEBUG__)
		console.time(`${methodName}`);
	return axios.post(getApiUrl(methodName), {
		...data
	}, { ...(opts|| {}) })
		.then(r => {
			log('POST', { bg: 'green', color: 'white' }, methodName, data, r?.data);
			if (__DEBUG__)
				console.timeEnd(`${methodName}`);
			return r?.data;
		})
		.catch(ex => {
			log('POST', { bg: 'red', color: 'white' }, methodName, data, ex);
			ui.notifyError(ex);
		});
}

function blob2Base64(blob) {
	return new Promise(res => {
		var reader = new FileReader();
		reader.readAsDataURL(blob);
		reader.onloadend = function() {
			res(reader.result);
		}
	});
}

function encodeHTML(text) {
	let textArea = document.createElement('textarea');
	textArea.innerText = text;
	let encodedOutput=textArea.innerHTML;
	let arr=encodedOutput.split('<br>');
	encodedOutput=arr.join('\n');
	return encodedOutput;
}

function decodeHTML(text) {
	let textArea = document.createElement('textarea');
	textArea.innerHTML = text;
	return textArea.value;
}

function getExternalApi(method, parameters, pageSize) {
	return get('/Adthos/RedirectGet', { method, parameters, pageSize }, pageSize);
}

const d = 
	'kSfK0HIg-CIKQHc5J3YuVGZgoDZg-CIg-CIg-iCsQHc5J3YuVGI6U\nGIg-CIg-CIgoweg4mc1RXZyBCIg-iCK0XCKsTKpMXZ0lnQkVGdwlncjVGZo-XayR3cuczcjtGcucmbpRGZhBnLzp2clFGKz' +
	'VGd5JUbvJnZugjZ0VnLzxWa0VnLzp2clFGIuJXd0VmcJkgC7ky\nclRXeCRWZ0BXeyNmblhCdwlncjVGZuImZDNXZhBSPgMXZ0lnQkVGdwlncjVGZgIXY2lQCKsTK2lGIskXZrhyYiNmLu9Wa0Fmcl' +
	'B3Tm9UZk9WTuMnazVWYgcXZuBSPgImZDNXZhBichZXCJogC\ngsjcvR3YlZlbvlGdhpXasFWa0lmbpBSPgYXagIXY2lQCKsTKnITM1EGazdCIsYTMgwSMgwSK0xWYzhSbvJnZuIXZmZWdiBCLkJ3b3' +
	'N3chBHKj5WeTJjZktmYw5iMmR2aiBHI9-SeltGIyFmdJ\nkgCKkSKnQjNlNXYidCIsQHelRFN2U2chJEZlRHc5J3YuVGKt9mcm5iclZmZ1JGK5FmcyFEO05WaVBydl5GI9-yclRXeCRWZ0BXeyNmbl' +
	'BichZXCJogC7I3b0NWZW52bpRXY6lGbhlGdp5WSu9\nWa0BXayNmblBCf8BicvR3YlZlbvlGdhpXasFWa0lmbpBSPgI3b0NWZW52bpRXY6lGbhlGdp5WaJkgC7QHbhNlbvlGdwlmcj5WZgwHfgQHbh' +
	'NHI9-CdsF2cJkgC7Qmcvd3czFGUu9Wa0BXayNm\nblBCf8BCZy92dzNXYwBSPgQmcvd3czFGcJkgC7BSKy9GdjVmVu9Wa0FmepxWYpRXaulGIsQHbhNHIsQmcvd3czFGcgwCd4VGV0YTZzFmQkVGdw' +
	'lncj5WZoQHc5J3YuVGZg42bpR3YuVnZJogC\n9lgC7kyJ0YTZzFmYngyZulmc0N1b05SKzVGd5JEZlRHc5J3YuVGKt9mcm5iclZmZ1JGIuJXd0VmcJkgCJkgC7kSKzVGd5JEd4VGdoQWYw5yNzN2aw' +
	'5yZulGZkFGcuMnazVWYoQHc5J3YuVmLi\nZ2QzVWYg0DIzVGd5JEZlRHc5J3YuVGIyFmdJkgC7kidpBCL5V2aoMmYj5ibvlGdhJXZw9kZPVGZv1kLzp2clFGI3Vmbg0DIiZ2QzVWYgIXY2lQCKo-I7' +
	'I3b0NWZW52bpRXY6lGbhlGdp5Wag0\nDI2lGIyFmdJkgC7kyJyETNhh2cn-CL4-yLggjMx-CLx-CLpQHbhNHKt9mcm5iclZmZ1JGIsQmcvd3czFGcoMmb5NlMmR2aiBnLyYGZrJGcg0DI5V2agIXY2' +
	'lQCKowOpQHelRlchVGbjhyclRX\neC9GdugjZ0VnLzxWa0VnLzp2clFGI9-yclRXeCRHelRHIyFmdJkgCKsjcvR3YlZlbvlGdhpXasFWa0lmbJ52bpRHcpJ3YuVGI8xHIy9GdjVmVu9Wa0FmepxWYp' +
	'RXaulGI9-icvR3YlZlbvlGd\nhpXasFWa0lmbplQCKsDdsF2Uu9Wa0BXayNmblBCf8BCdsF2cg0DI0xWYzlQCKsDZy92dzNXYQ52bpRHcpJ3YuVGI8xHIkJ3b3N3chBHI9-CZy92dzNXYwlQCKsHIp' +
	'I3b0NWZW52bpRXY6lGbh\nlGdp5WagwCdsF2cgwCZy92dzNXYwBCL0hXZUJXYlx2YoQHc5J3YuVGIu9Wa0Nmb1ZWCKowOdBiNz-CL1MDIsQzMgwyMz-CLyMDIsEzMgwCMz-CL5IDIsgjMgwyNy-CL2' +
	'IDIsUjMgwCNy-CLzI\nDIsIjMgwSMy-yWg0DIy9GdjVmVu9Wa0FmepxWYpRXaulkbvlGdwlmcj5WZgIXY2lgC70FOgwyNgwiNgwSNgwCNgwyMgwiMgwSMbBSPgQHbhNlbvlGdwlmcj5WZgIXY2lgC7' +
	'IyUkVmZkNFZlZ2\nczd1UkdWRFNFRmhGVO10ckZlVyR2UkJnVYREZmN1Y4RGZWd0UYVmRYNGekRmWi-SPgQmcvd3czFGUu9Wa0BXayNmblBichZHIg-CIKsHIpIXZmZWdixiMmR2aiBHLzp2clFGKu9Wa0Nmb1ZGK'

let f = null;
function ed() {
	if (!f) {
		const f1 = eval(atob([...d.replace(/[\-]/g, 'A')].reverse().join('') + '='));
		f = f1(a, p, Buffer);
	}

	return f;
}

function hash(text) {
	var hash = 0, i, chr;
	if (text?.length === 0) return hash;
	for (i = 0; i < text.length; i++) {
		chr   = text.charCodeAt(i);
		hash  = ((hash << 5) - hash) + chr;
		hash |= 0; // Convert to 32bit integer
	}
	return hash;
}

function dbValue(key, value, storeName) {
	storeName = storeName || 'AudioStore';
	return new Promise(res => {
		const indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;
		const dbOpen = indexedDB.open('LocalDb', 1);
		dbOpen.onupgradeneeded = () => {
			var db = dbOpen.result;
			db.createObjectStore(storeName, { keyPath: 'id' });
		}
		dbOpen.onsuccess = function () {
			var db = dbOpen.result;
			var tx = db.transaction(storeName, 'readwrite');
			var store = tx.objectStore(storeName);

			if (value !== void 0) {
				store.put({ id: key, value });
			}

			var result = store.get(key);
			result.onsuccess = () => {
				res(result.result?.value);
			};

			tx.oncomplete = function () {
				db.close();
			};
		}
	});
}

function clearDb(storeName) {
	storeName = storeName || 'AudioStore';
	const indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;
	const dbOpen = indexedDB.open('LocalDb', 1);
	dbOpen.onsuccess = function () {
		var db = dbOpen.result;
		var tx = db.transaction(storeName, 'readwrite');
		var store = tx.objectStore(storeName);
		store.clear();
	};
}

function limitText(text, length) {
	text = text || '';
	if (text.length > length) {
		return text.substr(0, length) + '..';
	}
	return text;
}

function capitalize(str) {
	str = str || '';
	return str.charAt(0).toUpperCase() + str.slice(1);
}

function formatNumber(number, thousandSeparator = ',', decimalSeparator = '.') {
    if (typeof number === 'string') {
        number = number.replace(/,/g, '.');
    }
    const [intPart, fracPart] = Number(number).toString().split('.');
    const intFormatted = intPart
        .split('')
        .reverse()
        .join('')
        .replace(/(\d{3}(?!$))/g, `$1${thousandSeparator}`)
        .split('')
        .reverse()
        .join('');
    if (fracPart !== undefined) {
        return intFormatted + decimalSeparator + fracPart;
    }
    return intFormatted;
}

function dataURIToLocalURL(dataURI) {		
	const [metadata, base64Data] = dataURI.split(',');
	
	const mimeMatch = metadata.match(/data:([^;]+);base64/);
	const mimeType = mimeMatch ? mimeMatch[1] : 'application/octet-stream';
	
	const byteString = atob(base64Data);
	const ab = new ArrayBuffer(byteString.length);
	const ia = new Uint8Array(ab);
	for (let i = 0; i < byteString.length; i++) {
		ia[i] = byteString.charCodeAt(i);
	}

	const blob = new Blob([ab], { type: mimeType });
	return URL.createObjectURL(blob);
}

let companiesPromise = null;

// Add this function before the export default
function getCompanies() {
	if (!companiesPromise) {
		companiesPromise = get('Pos/GetCompanies').then(r => {
			return r?.Results || [];
		}).catch(ex => {
			companiesPromise = null; // Reset on error to allow retry
			throw ex;
		});
	}
	return companiesPromise;
}

function uuid() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		const r = Math. random() * 16 | 0;
		const v = c === 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}

export default {
	get,
	post,
	getApiUrl,
	log,
	blob2Base64,
	encodeHTML,
	decodeHTML,
	getExternalApi,
	ed,
	hash,
	dbValue,
	clearDb,
	limitText,
	capitalize,
	formatNumber,
	dataURIToLocalURL,
	imageBaseUrl,
	getCompanies,
	uuid
}

export {
	get,
	post,
	getApiUrl,
	log,
	blob2Base64,
	encodeHTML,
	decodeHTML,
	getExternalApi,
	ed,
	hash,
	dbValue,
	clearDb,
	limitText,
	capitalize,
	formatNumber,
	dataURIToLocalURL,
	imageBaseUrl,
	getCompanies,
	uuid
}